import React, { Component } from "react";
import { Box, Center, Flex, Grid, IconButton, Text } from "@chakra-ui/react";
import {
  GalleryTypeHeaderTitle,
  ImageItem,
} from "apps/simplified-web/src/_components/common/statelessView";
import TLDRSwiper from "apps/simplified-web/src/_components/common/TLDRSwiper";
import { StyledMarketPlaceSwiperButton } from "apps/simplified-web/src/_components/styled/details/stylesDetails";
import { FaChevronLeft, FaChevronRight, FaPencilAlt } from "react-icons/fa";
import { batch, connect, useDispatch, useSelector } from "react-redux";
import {
  onClickSetAsBackground,
  prepareAssetPayload,
} from "apps/simplified-web/src/_utils/common";
import {
  ADD_MASK,
  REPLACE_BKG_IMAGE,
  REPLACE_META,
} from "apps/simplified-web/src/_actions/types";
import {
  wsAddLayer,
  wsAddMusic,
  wsCopyFromTemplate,
  wsUpdateMusic,
} from "apps/simplified-web/src/_actions/webSocketAction";
import { updateStoryMusic } from "apps/simplified-web/src/_actions/storiesActions";
import { closeSlider } from "apps/simplified-web/src/_actions/sidebarSliderActions";
import { useTranslation, withTranslation } from "react-i18next";
import EditBrandkitModal from "./EditBrandkitModal";

const BrandkitAssetsSwiper = (props) => {
  const dispatch = useDispatch();
  const selectedBrandkit = useSelector(
    (state) => state.brandKit.selectedBrandkit
  );
  const activePage = useSelector((state) => state.editor.activePage);
  const sidebarSlider = useSelector((state) => state.sidebarSlider);
  const editor = useSelector((state) => state.editor);
  const story = useSelector((state) => state.story);

  const { t } = useTranslation(["planner"]);

  const { header, viewAll } = props;
  const { logos: assets } = selectedBrandkit;

  let childElements = [];

  if (assets.length > 0) {
    childElements = assets.map((asset, index) => {
      const payload = prepareAssetPayload(asset, activePage.id);

      return (
        <Box
          key={asset.id}
          onClick={() => addLayerCallback(payload)}
          // onDragStart={(e) => onDragItem(e, item)}
          cursor="pointer"
          pos="relative"
          className={"item item-element brandkit-asset-item"}
          mr={3}
          w={viewAll ? "100%" : "33%"}
          sx={{
            img: {
              maxHeight: "100%",
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ImageItem
            data={payload}
            key={asset.id}
            url={
              asset.thumbnail_cover_image
                ? asset.thumbnail_cover_image
                : asset.thumbnail
            }
            alt={"asset"}
            width={asset?.thumbnail_width}
            height={asset?.thumbnail_height} //to make or flexible at places
            source={"Simplified"}
            type={"asset"}
            itemWidth={100}
            showOverlayInfo={false}
            isUsedInSwiper={viewAll ? false : true}
          />
        </Box>
      );
    });
  }

  return (
    <Box mb={3}>
      {header}

      {viewAll ? (
        <Flex width="calc(100% + 10px)" h="100%" overflow="auto">
          <Grid
            templateColumns="repeat(2, 1fr)"
            gap="3"
            alignContent="start"
            w="100%"
            mr="0.5rem"
          >
            {childElements}
          </Grid>
        </Flex>
      ) : (
        <>
          {assets.length > 0 ? (
            <div
              id="template-gallery-scrollable-wrapper"
              className="tab-brandkit-assets-gallery"
            >
              <TLDRSwiper swiperParams={swiperParams}>
                {childElements}
              </TLDRSwiper>
            </div>
          ) : (
            <Center>
              <Text color="gray.300" fontSize="1rem">
                {t("brandkit.no_logos_message")}
              </Text>
            </Center>
          )}
        </>
      )}
    </Box>
  );

  async function addLayerCallback(item) {
    const { action } = sidebarSlider;
    const { canvasRef } = props;

    if (action === REPLACE_META) {
      canvasRef.handler.imageHandler.replaceImageSource(
        item?.payload?.src,
        item?.payload?.userProperty,
        item?.content
      );
    } else if (action === REPLACE_BKG_IMAGE) {
      onClickSetAsBackground(canvasRef, item.content.url, item.content);
    } else if (action === ADD_MASK) {
      const activeTextObj = canvasRef.handler.canvas.getActiveObject();
      canvasRef.handler.maskHandler.replaceMaskImage(
        activeTextObj,
        item,
        { offsetX: 0, offsetY: 0 },
        "push"
      );
    } else {
      if (item.mime === "shape") {
        if (item.type === "icon") {
          let payload = item;
          if (!payload) {
            return;
          }
          dispatch(wsAddLayer(activePage.id, payload));
        } else {
          dispatch(wsCopyFromTemplate(activePage.id, item.content.id));
        }
      } else if (item.mime === "audio") {
        const musicPayload = item;
        const payload = {
          ...musicPayload,
          action: "add",
        };

        batch(() => {
          if (story?.payload?.payload?.music) {
            dispatch(
              wsUpdateMusic({
                music: payload,
              })
            );
          } else {
            dispatch(
              wsAddMusic({
                music: payload,
              })
            );
          }

          dispatch(closeSlider()); // close slider once music added
          dispatch(updateStoryMusic(payload));
        });
      } else if (item.mime === "video") {
        dispatch(wsAddLayer(activePage.id, item));
      } else if (item.content) {
        dispatch(wsAddLayer(activePage.id, item));
      } else {
        dispatch(wsCopyFromTemplate(activePage.id, item));
      }
    }
  }
};

let swiperParams = {
  spaceBetween: 15,
  slidesPerView: 3,
  noSwiping: true,
  freeMode: true,
  shouldSwiperUpdate: true,
  runCallbacksOnInit: true,
  containerClass: "element-swiper-container show-on-hover",
  mousewheel: false,
  lazy: true,
  preloadImages: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    disabledClass: "swiper-button-disabled",
  },
  renderPrevButton: () => (
    <StyledMarketPlaceSwiperButton
      className="swiper-button-prev"
      variance="left"
    >
      <IconButton icon={<FaChevronLeft />} isRound minW={7} height={7} />
    </StyledMarketPlaceSwiperButton>
  ),
  renderNextButton: () => (
    <StyledMarketPlaceSwiperButton
      className="swiper-button-next"
      variance="right"
    >
      <IconButton icon={<FaChevronRight />} isRound minW={7} height={7} />
    </StyledMarketPlaceSwiperButton>
  ),
};

export default BrandkitAssetsSwiper;
